import React from 'react';
import {makeStyles} from '@material-ui/core/styles';
import {useTranslation} from 'react-i18next';
import {Button, CardActions} from '@material-ui/core';
import AdminsList from '../components/admins/AdminsList';
import ReactsCard from "../components/ui/ReactsCard";
import {useNavigate} from "react-router-dom";
import {WithOrganization} from "../components/organizations/organization-context";


const useStyles = makeStyles(theme => ({
    root: {
        minWidth: 250,
        margin: theme.spacing(4)
    },
    action: {
      justifyContent: 'flex-end'
    },
    table: {
        marginTop: '2rem',
        display: 'flex',
        justifyContent: 'center'
    }
}));

const Admins: React.FC<WithOrganization> = ({currentOrganization}) => {
    const classes = useStyles();
    const {t} = useTranslation();
    const navigate = useNavigate();

    const addAdmin = () => {
        navigate("/admins/add");
    };

    return (
               <ReactsCard title={t('Admin.Title')} className={classes.root}>
                        <CardActions className={classes.action}>
                                <Button variant="contained" color="primary" size="medium"
                        onClick={addAdmin}>
                    { t('Admin.AddAdminTitle') }
                </Button>
            </CardActions>
                        <div className={classes.table}>
                                <AdminsList />
            </div>
        </ReactsCard>
    )
};

export default Admins;
